/**
 * Every name the session_metrics action publishes a session topic's stats
 * under starts with this. The session's Topics tab shows those stats; the
 * session's Metrics tab and dashboard onboarding and seeding leave them out.
 */
export const TOPIC_STATS_PREFIX = "topic_stats.";

/** Whether `name` is a session topic stat rather than a metric a customer published. */
export function isTopicStatName(name: string): boolean {
  return name.startsWith(TOPIC_STATS_PREFIX);
}
